import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";

const UserAuditLogTable = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = useState('default');

  const [logs] = useState([
    {
      id: 1,
      admin: "Superadmin",
      email: "superadmin@system.com",
      role: "Super Admin",
      action: "Updated Personal Info",
      details: "Changed Member Account value from MA-40568480 to MA-40568476",
      date: "03-Sep-2025 10:30 AM"
    },
    {
      id: 2,
      admin: "John Admin",
      email: "john.admin@system.com",
      role: "Admin",
      action: "Added Loyalty Points",
      details: "100 Loyalty Points added",
      date: "02-Sep-2025 05:15 PM"
    }
  ]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          <div className=" form">
            <Select
              fullWidth
              value={Status}
              onChange={(e: SelectChangeEvent) =>
                setStatus(e.target.value)
              }>
              <MenuItem disabled value="default">Select Role</MenuItem>
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Super">Super Admin</MenuItem>
            </Select>
          </div>
        </div>
      </div>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Admin/User</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Details</TableCell>
              <TableCell>Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow hover key={log.id}>
                {/* Admin Info */}
                <TableCell>
                  <div className="user_block">
                    <figure><img src="/static/images/user_placeholder.png" alt="Images" /></figure>
                    <p>
                      <b>{log.admin}</b>
                      <span>{log.email}</span>
                    </p>
                  </div>
                </TableCell>

                {/* Role */}
                <TableCell>{log.role}</TableCell>

                {/* Action */}
                <TableCell>{log.action}</TableCell>

                {/* Details */}
                <TableCell>{log.details}</TableCell>

                {/* Date */}
                <TableCell>{log.date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default UserAuditLogTable;
